var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.95 6C13.95 5.43 14.2832 4.935 14.7715 4.68C15.2365 4.4325 15.5 3.9225 15.5 3.405V1.5C15.5 0.675 14.8025 0 13.95 0H1.55C0.6975 0 0.00774999 0.6675 0.00774999 1.4925V3.405C0.00774999 3.9225 0.2635 4.4325 0.73625 4.6725C1.2245 4.935 1.55 5.43 1.55 6C1.55 6.57 1.21675 7.0725 0.7285 7.32C0.2635 7.5675 0 8.0775 0 8.595V10.5C0 11.325 0.6975 12 1.55 12H13.95C14.8025 12 15.5 11.325 15.5 10.5V8.595C15.5 8.0775 15.2365 7.5675 14.7715 7.32C14.2832 7.065 13.95 6.57 13.95 6ZM9.6875 9.075L7.75 7.875L5.8125 9.0825C5.518 9.2625 5.13825 9 5.23125 8.67L5.8125 6.51L4.03 5.1C3.96964 5.05178 3.92568 4.98709 3.90383 4.91436C3.88199 4.84162 3.88327 4.76421 3.90752 4.69219C3.93177 4.62017 3.97786 4.55689 4.03979 4.51057C4.10172 4.46425 4.17662 4.43705 4.25475 4.4325L6.54875 4.305L7.38575 2.2425C7.5175 1.9275 7.9825 1.9275 8.1065 2.2425L8.9435 4.3125L11.2375 4.44C11.5862 4.4625 11.7335 4.89 11.4623 5.1075L9.67975 6.5175L10.2687 8.6625C10.3617 9 9.982 9.2625 9.6875 9.075Z",
    fill: "#42AAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOa);
export default __webpack_public_path__ + "static/media/oa.50ace574ec36af8d1db4677f016ec1df.svg";
export { ForwardRef as ReactComponent };